import {
  getAvailabilityStatus,
  getBrandName,
  getCategory1,
  getCategory2,
  getCategory3,
  getColor,
  getCommercialOperationSticker,
  getDiscountPrice,
  getFinalPrice,
  getName,
  getRealSku,
  getSizeLabel,
} from 'services/product/attributes';
import { GtmInputProductType } from 'types/gtm/InputData';
import { ProductType } from 'types/ProductListing/ProductListing';

type ProductAdditionalDataType = Pick<GtmInputProductType, 'listPosition'>;

function formatUnwantedValues<T>(data: T): T {
  const unwantedValues = ['', null];
  const entries = Object.entries(data);

  for (const [key, value] of entries) {
    if (unwantedValues.includes(value)) {
      data[key] = undefined;
    }
  }

  return data;
}

// Format product attributes to prepare it for GTM processing
export function formatListingProduct(
  { attributes }: ProductType,
  additionalData?: ProductAdditionalDataType
): GtmInputProductType {
  const discountPrice = parseFloat(getDiscountPrice(attributes));
  const finalPrice = parseFloat(getFinalPrice(attributes));

  return formatUnwantedValues<GtmInputProductType>({
    availabilityStatus: getAvailabilityStatus(attributes),
    brandName: getBrandName(attributes),
    category1: getCategory1(attributes),
    category2: getCategory2(attributes),
    category3: getCategory3(attributes),
    color: getColor(attributes),
    discountPrice: discountPrice > 0 ? discountPrice : undefined,
    finalPrice: finalPrice > 0 ? finalPrice : undefined,
    name: getName(attributes),
    realSku: getRealSku(attributes),
    size: getSizeLabel(attributes),
    stickerOpeco: getCommercialOperationSticker(attributes),
    ...additionalData,
  });
}

// Format list of product attributes to prepare it for GTM processing
export function formatListingProducts(
  products: ProductType[]
): GtmInputProductType[] {
  return products.map((product, index) =>
    formatListingProduct(product, { listPosition: index + 1 })
  );
}
